import { Theme } from '@benchlabs/react-design-system';

const fontSize = '0.8rem';

export const setupBusinessServicesStyles = (theme: Theme) => ({
  fontSize,

  '.MuiStack-root': {
    gap: '12px',
  },

  '.MuiTypography-root': {
    color: theme.palette.text.secondary,
    paddingTop: '10px', //Aligns the text with the input field when an error message is displayed
    fontSize,
  },

  '.MuiLink-root': {
    color: theme.palette.primary.main,
  },

  '.MuiFormLabel-root': {
    fontSize,
  },

  '.MuiTextField-root': {
    maxWidth: '279px',
    fontSize,
    '.MuiInputBase-root': {
      height: '40px',
      fontSize,
    },
  },

  '.MuiInputBase-root': {
    fontSize,
  },

  '.MuiButton-root': {
    fontSize,
  },

  '.MuiSelect-select': {
    paddingRight: '3px !important',
  },

  '.bktools-primary': {
    backgroundColor: '#098B8C',
  },
});
